import React, { Suspense } from 'react';
import ProgressBox from './ProgressBox';

export function SuspenseDefault({ children }: { children: React.ReactNode }) {
	return <Suspense fallback={<ProgressBox />}>{children}</Suspense>;
}
